export default "/images/fbb62c7cc500d81cda2db2ce247ea035.png";